export default __webpack_public_path__ + "assets/fonts/4c79ae654591597333829959731ddb9e.woff2";